import { useEffect, useState } from 'react';
import { apiClient } from '../lib/api-client';

function readAuthErrorFromUrl(): string | null {
  try {
    const params = new URLSearchParams(window.location.search);
    const err = params.get('auth_error');
    if (!err) return null;
    window.history.replaceState({}, '', window.location.pathname);
    return err;
  } catch {
    return null;
  }
}

export function Login() {
  const [identityDriver, setIdentityDriver] = useState<string>('azure');
  const [loadingConfig, setLoadingConfig] = useState(true);
  const [authError, setAuthError] = useState<string | null>(() => readAuthErrorFromUrl());

  useEffect(() => {
    void (async () => {
      try {
        const cfg = await apiClient.getPortalConfig();
        if (cfg.identityDriver) setIdentityDriver(cfg.identityDriver);
      } catch {
        // default to azure
      } finally {
        setLoadingConfig(false);
      }
    })();
  }, []);

  const isKeycloak = identityDriver === 'keycloak';

  const handleLogin = () => {
    setAuthError(null);
    const loginPath = isKeycloak ? '/api/oidc-auth/login' : '/api/auth/login';
    window.location.replace(`${window.location.origin}${loginPath}`);
  };

  const subtitle = isKeycloak
    ? 'Sign in with your organization SSO'
    : 'Sign in with your Microsoft account';
  const buttonLabel = isKeycloak ? 'Sign in with SSO' : 'Sign in with Microsoft';

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="max-w-md w-full space-y-8 p-8">
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <img
              src="/icons/maxiron.png"
              alt="Maxiron"
              className="h-16 w-auto object-contain dark:hidden"
            />
            <img
              src="/icons/maxiron_dark.png"
              alt="Maxiron"
              className="h-16 w-auto object-contain hidden dark:block"
            />
          </div>
          <p className="text-gray-600 dark:text-gray-400">
            {loadingConfig ? 'Loading…' : subtitle}
          </p>
        </div>

        {authError && (
          <div className="rounded-lg border border-red-200 bg-red-50 text-red-700 dark:border-red-900 dark:bg-red-950 dark:text-red-300 px-4 py-3 text-sm">
            {authError}
          </div>
        )}

        <button
          type="button"
          onClick={handleLogin}
          disabled={loadingConfig}
          className="w-full flex items-center justify-center gap-3 px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg shadow-sm text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors disabled:opacity-50"
        >
          {!isKeycloak && (
            <svg className="w-5 h-5" viewBox="0 0 21 21">
              <rect x="1" y="1" width="9" height="9" fill="#f25022" />
              <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
              <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
              <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
            </svg>
          )}
          {buttonLabel}
        </button>
      </div>
    </div>
  );
}
